import { useTranslation } from "react-i18next";
import RobinPage from "../components/RobinPage";
import { EnhancedPartnerStatisticsDashboard } from "../components/EnhancedPartnerStatisticsDashboard";

function Dashboard() {
  const { t } = useTranslation();
  
  return (
    <RobinPage title={t("label.menu.dashboard")}>
      <EnhancedPartnerStatisticsDashboard />
    </RobinPage>
  );
}

export default Dashboard;
